module.exports = __webpack_public_path__ + "media/img/portal/banner-portal-img-2d41925a136d70ec85b40eae9a6133da.svg";